export default __webpack_public_path__ + "static/media/049-wafer.7b2095a0.svg";